// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../public/Georama_SemiCondensed-Regular.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Georama:wght@400&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Lato:wght@400&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Georama SemiCondensed";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  font-weight: 400;
}

body {
  margin: auto;
  line-height: normal;
  font-family: var(--font-lato);
  font-size: 1rem;
  height: 100%;
  color: var(--secondary-color);
}

:root {
  /* fonts */
  --title: "Georama SemiCondensed";
  --font-lato: Lato;
  --navbar1: Georama;

  /* font sizes */
  --title-1-desktop-size: 3rem;
  --title-1-tablet-size: 2.5rem;
  --title-2-desktop-size: 2.2rem;
  --title-2-tablet-size: 1.6rem;
  --title-3-desktop-size: 1.75rem;
  --title-3-tablet-size: 1.375rem;
  --title-4-desktop-size: 1.5rem;
  --title-4-tablet-size: 1.19rem;
  --title-5-desktop-size: 1.25rem;
  --title-5-tablet-size: 1rem;

  /* Colors */
  --primary-color: #e40032;
  --secondary-color: #333f4c;
  --gray: #d9d9d9;
  --lightGray: #f7f6f7;
  --white: #fff;
  --info-color: #1581bf;
  --success-color: #8bc74e;
  --warning-color: #ecaa07;
  --pending-color: #e5e912;

  /* Gaps */
  --gap-md: 0.31rem;
  --gap-lg: 1rem;

  /* Paddings */
  --padding-sm: 1.38rem;
  --padding-md: 3rem;
}

.section {
  margin: auto;
  margin-top: 3rem;
}

.displayFlexCenter {
  display: flex;
  justify-content: center;
  align-items: center;
}

.spaceBetweenContainer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.spaceBetweenContainerStart {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.flexWrap {
  display: flex;
  flex-wrap: wrap;
}

.flexWrapStart {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
}

.flexWrapSpaceBetween {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.flexColumnContainer {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.flexColumnContainerAlignStart {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
}

.userCard {
  width: 70%;
  margin: 0 auto;
  padding: 2rem;
  border-radius: 0.5rem;
  box-shadow: 0 0 1rem rgba(0, 0, 0, 0.2);
}

.formContainer {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1.5rem;
}

.mediumContainer {
  width: 48%;
}

.largeContainer {
  width: 90%;
}

.badgeContainer {
  width: 11rem;
}

.select {
  margin-bottom: 1rem;
}

textarea,
p {
  text-align: justify;
}

.link {
  margin-top: 2rem;
}

.actionIcon {
  margin-right: 0.5rem;
  cursor: pointer;
  color: var(--secondary-color);
}

.actionIcon:hover {
  color: var(--primary-color);
}

.button {
  width: 8.75rem;
  cursor: pointer;
  margin: 2rem 2rem 1rem 0;
}

.fit {
  width: -moz-fit-content;
  width: fit-content;
}

.largeButton {
  width: 90%;
  margin-top: 2rem;
}

.message {
  display: none;
  color: var(--primary-color);
}

li:hover {
  background-color: var(--gray);
  cursor: pointer;
}

.footerContainer {
  bottom: 0;
  position: absolute;
  width: 100%;
}

.headerEditor {
  background-color: white !important;
}

.buttonIconDisabled {
  cursor: not-allowed;
  opacity: 0.3;
  margin-right: 0.5rem;
}

.toggleButton {
  width: 100%;
}

/* Overload the css of the library loader */
.spinnerPlayLoading {
  width: 2rem !important;
  height: 2rem !important;
  border-width: 0.25em !important;
  margin-right: 0.5rem;
}

.spinnerPlayLoadingOutput {
  width: 2rem !important;
  height: 2rem !important;
  border-width: 0.25em !important;
}

.iconToast {
  margin-right: 0.5rem;
  color: var(--warning-color);
}

.buttonHeaderCard {
  align-items: center;
  display: flex;
  gap: 0.8rem;
}

.textTruncate {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.testAccordionSection {
  margin-bottom: 3rem;
}

.accordionCard {
  margin: 1rem;
  height: 75vh;
  overflow: auto;
}
`, "",{"version":3,"sources":["webpack://./src/style.css"],"names":[],"mappings":"AAGA;EACE,oCAAoC;EACpC,4CAAuD;EACvD,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,6BAA6B;EAC7B,eAAe;EACf,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,gCAAgC;EAChC,iBAAiB;EACjB,kBAAkB;;EAElB,eAAe;EACf,4BAA4B;EAC5B,6BAA6B;EAC7B,8BAA8B;EAC9B,6BAA6B;EAC7B,+BAA+B;EAC/B,+BAA+B;EAC/B,8BAA8B;EAC9B,8BAA8B;EAC9B,+BAA+B;EAC/B,2BAA2B;;EAE3B,WAAW;EACX,wBAAwB;EACxB,0BAA0B;EAC1B,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,qBAAqB;EACrB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;;EAExB,SAAS;EACT,iBAAiB;EACjB,cAAc;;EAEd,aAAa;EACb,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,cAAc;EACd,aAAa;EACb,qBAAqB;EACrB,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,WAAW;AACb;;AAEA,2CAA2C;AAC3C;EACE,sBAAsB;EACtB,uBAAuB;EACvB,+BAA+B;EAC/B,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;EACE,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,cAAc;AAChB","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Georama:wght@400&display=swap\");\n@import url(\"https://fonts.googleapis.com/css2?family=Lato:wght@400&display=swap\");\n\n@font-face {\n  font-family: \"Georama SemiCondensed\";\n  src: url(\"../public/Georama_SemiCondensed-Regular.ttf\");\n  font-weight: 400;\n}\n\nbody {\n  margin: auto;\n  line-height: normal;\n  font-family: var(--font-lato);\n  font-size: 1rem;\n  height: 100%;\n  color: var(--secondary-color);\n}\n\n:root {\n  /* fonts */\n  --title: \"Georama SemiCondensed\";\n  --font-lato: Lato;\n  --navbar1: Georama;\n\n  /* font sizes */\n  --title-1-desktop-size: 3rem;\n  --title-1-tablet-size: 2.5rem;\n  --title-2-desktop-size: 2.2rem;\n  --title-2-tablet-size: 1.6rem;\n  --title-3-desktop-size: 1.75rem;\n  --title-3-tablet-size: 1.375rem;\n  --title-4-desktop-size: 1.5rem;\n  --title-4-tablet-size: 1.19rem;\n  --title-5-desktop-size: 1.25rem;\n  --title-5-tablet-size: 1rem;\n\n  /* Colors */\n  --primary-color: #e40032;\n  --secondary-color: #333f4c;\n  --gray: #d9d9d9;\n  --lightGray: #f7f6f7;\n  --white: #fff;\n  --info-color: #1581bf;\n  --success-color: #8bc74e;\n  --warning-color: #ecaa07;\n  --pending-color: #e5e912;\n\n  /* Gaps */\n  --gap-md: 0.31rem;\n  --gap-lg: 1rem;\n\n  /* Paddings */\n  --padding-sm: 1.38rem;\n  --padding-md: 3rem;\n}\n\n.section {\n  margin: auto;\n  margin-top: 3rem;\n}\n\n.displayFlexCenter {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.spaceBetweenContainer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.spaceBetweenContainerStart {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n}\n\n.flexWrap {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.flexWrapStart {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-start;\n}\n\n.flexWrapSpaceBetween {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n}\n\n.flexColumnContainer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n}\n\n.flexColumnContainerAlignStart {\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  flex-direction: column;\n}\n\n.userCard {\n  width: 70%;\n  margin: 0 auto;\n  padding: 2rem;\n  border-radius: 0.5rem;\n  box-shadow: 0 0 1rem rgba(0, 0, 0, 0.2);\n}\n\n.formContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 1.5rem;\n}\n\n.mediumContainer {\n  width: 48%;\n}\n\n.largeContainer {\n  width: 90%;\n}\n\n.badgeContainer {\n  width: 11rem;\n}\n\n.select {\n  margin-bottom: 1rem;\n}\n\ntextarea,\np {\n  text-align: justify;\n}\n\n.link {\n  margin-top: 2rem;\n}\n\n.actionIcon {\n  margin-right: 0.5rem;\n  cursor: pointer;\n  color: var(--secondary-color);\n}\n\n.actionIcon:hover {\n  color: var(--primary-color);\n}\n\n.button {\n  width: 8.75rem;\n  cursor: pointer;\n  margin: 2rem 2rem 1rem 0;\n}\n\n.fit {\n  width: fit-content;\n}\n\n.largeButton {\n  width: 90%;\n  margin-top: 2rem;\n}\n\n.message {\n  display: none;\n  color: var(--primary-color);\n}\n\nli:hover {\n  background-color: var(--gray);\n  cursor: pointer;\n}\n\n.footerContainer {\n  bottom: 0;\n  position: absolute;\n  width: 100%;\n}\n\n.headerEditor {\n  background-color: white !important;\n}\n\n.buttonIconDisabled {\n  cursor: not-allowed;\n  opacity: 0.3;\n  margin-right: 0.5rem;\n}\n\n.toggleButton {\n  width: 100%;\n}\n\n/* Overload the css of the library loader */\n.spinnerPlayLoading {\n  width: 2rem !important;\n  height: 2rem !important;\n  border-width: 0.25em !important;\n  margin-right: 0.5rem;\n}\n\n.spinnerPlayLoadingOutput {\n  width: 2rem !important;\n  height: 2rem !important;\n  border-width: 0.25em !important;\n}\n\n.iconToast {\n  margin-right: 0.5rem;\n  color: var(--warning-color);\n}\n\n.buttonHeaderCard {\n  align-items: center;\n  display: flex;\n  gap: 0.8rem;\n}\n\n.textTruncate {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.testAccordionSection {\n  margin-bottom: 3rem;\n}\n\n.accordionCard {\n  margin: 1rem;\n  height: 75vh;\n  overflow: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
